import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBorderTopBottom$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBorderTopBottom extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-border-top-bottom", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.99996 4.50195C5.36604 4.50195 4.82397 4.89519 4.60436 5.45103C4.59564 5.48251 4.58476 5.51377 4.57165 5.54466C4.40983 5.92587 3.96962 6.10373 3.58841 5.94191C3.20723 5.78011 3.02937 5.33998 3.1911 4.95879H3.18629C3.61007 3.8162 4.70992 3.00195 5.99996 3.00195H14C15.29 3.00195 16.3898 3.8162 16.8136 4.95879H16.8105C16.9723 5.34 16.7944 5.78019 16.4132 5.942C16.032 6.10381 15.5918 5.92596 15.4299 5.54474L15.4257 5.53446C15.4167 5.51245 15.4089 5.49026 15.4021 5.46794C15.1869 4.90318 14.6403 4.50195 14 4.50195H5.99996ZM3 11.2507C3 11.6649 3.33579 12.0007 3.75 12.0007C4.16421 12.0007 4.5 11.6649 4.5 11.2507V8.75073C4.5 8.33652 4.16421 8.00073 3.75 8.00073C3.33579 8.00073 3 8.33652 3 8.75073V11.2507ZM15.5 11.2507C15.5 11.6649 15.8358 12.0007 16.25 12.0007C16.6642 12.0007 17 11.6649 17 11.2507V8.75073C17 8.33652 16.6642 8.00073 16.25 8.00073C15.8358 8.00073 15.5 8.33652 15.5 8.75073V11.2507ZM4.60436 14.5526C4.82397 15.1085 5.36604 15.5017 5.99996 15.5017H14C14.6403 15.5017 15.1869 15.1005 15.4021 14.5357C15.4089 14.5134 15.4167 14.4912 15.4257 14.4692L15.429 14.4589C15.5908 14.0777 16.032 13.8998 16.4132 14.0617C16.7944 14.2235 16.9723 14.6637 16.8105 15.0449H16.8136C16.3898 16.1875 15.29 17.0017 14 17.0017H5.99996C4.70992 17.0017 3.61007 16.1875 3.18629 15.0449H3.1911C3.02937 14.6637 3.20723 14.2235 3.58841 14.0618C3.96962 13.8999 4.40983 14.0778 4.57165 14.459C4.58476 14.4899 4.59564 14.5212 4.60436 14.5526Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-border-top-bottom-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-border-top-bottom", "wpp-icon-border-top-bottom-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-border-top-bottom-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-border-top-bottom-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBorderTopBottom$1);
      }
      break;
  } });
}

const WppIconBorderTopBottom = WppIconBorderTopBottom$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBorderTopBottom, defineCustomElement };
